module.exports = __webpack_public_path__ + "static/img/p4.335a0bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/p4.png
// module id = UpqR
// module chunks = 0